import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ascendingBy } from '@shared/store/entity-state-store';
import { UserAccountQueries } from '@/app/platform/platform-data/queries/types';
import { UserAccountEntityStore } from '@/app/platform/platform-data/store/user-account.entity.store';
import { UserAccountEntity } from '@/app/platform/platform-data/models/user-account.entity';

const byUserName = ascendingBy<UserAccountEntity>('userName');

@Injectable({
  providedIn: 'root'
})
export class UserAccountStoreQueries implements UserAccountQueries {
  constructor(private readonly store: UserAccountEntityStore) {}

  readonly all$: Observable<UserAccountEntity[]> = this.store.selectAll(byUserName);

  getAll(): UserAccountEntity[] {
    return this.store.getAll(byUserName);
  }

  getHasCache(): boolean {
    return this.store.getHasCache();
  }

  one$(id: string): Observable<UserAccountEntity> {
    return this.store.selectEntity(id);
  }

  displayNameFor$(id: string): Observable<string> {
    return this.store.selectEntity(id).pipe(map(user => user?.displayName));
  }
}
